function updateTotalPrice() {
	// get active variant
	// get all active addon and * quantity
	// update the total price
	let priceList = [];
	let totalItems = 0;
	let hasPersonalizedCandle = false;
    let hasPersonalizedProsecco = false;
	let height = "150px";
	let browserWidth = window.innerWidth;

	if (browserWidth < 800) height = "180px";

	$(".addon-item.active").each(function () {
		const jarId = $(this).data("id");
		const itemPrice = $(this).data("price");
		const productType = $(this).data("product-type");
		let itemQuantity = 1;
		let subTotal = 0;

		if (productType === "addon") {
			itemQuantity = $(this).find(".des .addon-qty-container input").val();
		}

		subTotal = itemPrice * itemQuantity;
		totalItems = Number(totalItems) + Number(itemQuantity);
		priceList = parseInt(priceList + subTotal);

		if (jarId == "43576574050484") {
			hasPersonalizedProsecco = true;
		}
        if (jarId == "41886952325300") {
  			hasPersonalizedCandle = true;
  		}
	});

  if (hasPersonalizedProsecco) {
        $(".personalized-input-container.prosecco").css("height", height);
		$(".personalized-input-container.prosecco input").focus();
	} else {
		$(".personalized-input-container.prosecco").css("height", 0);
		$(".personalized-input-container.prosecco input").val("");
	}

	if (hasPersonalizedCandle) {
		$(".personalized-input-container.candle").css("height", height);
		$(".personalized-input-container.candle input").focus();
	} else {
		$(".personalized-input-container.candle").css("height", 0);
		$(".personalized-input-container.candle input").val("");
	}

	priceList = parseInt(
		priceList + $(".swatch_options input:checked+.swatch-element .prod-swatch-col-2").data("price")
	);

    var finalPrice = Shopify.formatMoney(priceList, currencyFormat);
	$(".total-price-addon").text(finalPrice.replace(".00", ""));
	$(".addon-prod-qty").text(totalItems);
}

$("body").on("click", ".single-product .link_hover", function (e) {
	const randomString = [
		"Awesome choice!",
		"They'll love it!",
		"It's in the bag!",
		"You're a goodie!",
	].at(Math.floor(Math.random() * 3));
	e.preventDefault();
	$(this).parents(".addon-item").addClass("active");
	$(this)
		.parents(".addon-item")
		.find(".image_hover")
		.html(`<span>${randomString}</span>`)
		.addClass("active");
	$(this).parents(".addon-item").find(".link_hover").addClass("active");
	$(this).parents(".addon-item").find(".addon-qty-container").show();

	updateTotalPrice();
});
$("body").on("click", ".single-product .image_hover", function (e) {
	e.preventDefault();
	$(this).parents(".addon-item").removeClass("active");
	$(this).parents(".addon-item").find(".image_hover").removeClass("active");
	$(this).parents(".addon-item").find(".link_hover").removeClass("active");
	$(this).parents(".addon-item").find(".addon-qty-container").hide();
	$(this).parents(".addon-item").find('.addon-qty-container span[data-func="minus"]').hide();
	$(this).parents(".addon-item").find(".addon-qty-container input").val(1);

	updateTotalPrice();
});

$(".addon-qty-container span").on("click", function () {
	const buttonFunc = $(this).data("func");
	let currentValue = $(this).parent(".addon-qty-container").find("input").val();
	if (buttonFunc === "plus") {
		$(this)
			.parent(".addon-qty-container")
			.find("input")
			.val(Number(currentValue) + 1);
		if (Number(currentValue) + 1 > 1)
			$(this).parent(".addon-qty-container").find("span[data-func='minus']").show();
	} else {
		$(this)
			.parent(".addon-qty-container")
			.find("input")
			.val(Number(currentValue) - 1);
		if (Number(currentValue) - 1 === 1)
			$(this).parent(".addon-qty-container").find("span[data-func='minus']").hide();
	}

	updateTotalPrice();
});

$(".addon-qty-container input").on("change", function (e) {
	if (e.target.value == 0) {
		$(this).val(1);
	}
	const buttonFunc = $(this).data("func");
	let currentValue = $(this).parent(".addon-qty-container").find("input").val();
	if (Number(currentValue) > 1)
		$(this).parent(".addon-qty-container").find("span[data-func='minus']").show();
	if (Number(currentValue) === 1)
		$(this).parent(".addon-qty-container").find("span[data-func='minus']").hide();

	updateTotalPrice();
});

$(".prod-swatch-label").on("click", function () {
	setTimeout(function () {
		updateTotalPrice();
		if (!isBAB) {$("html, body").animate({ scrollTop: $("#jars").offset().top - 50 }, 1000);}
		if (isBAB) {$("html, body").animate(
				{
					scrollTop: parseInt($(".posy-selection").offset().top - 200),
				},
				200
			);
                     $('.jar-item').removeClass('active');
                    
                   }

		return false;
	}, 300);
});

$(window).on("load", function () {
	var price_list = [];

	$(".addon-item.active").each(function () {
		var data_price = $(this).data("price");
		price_list = parseInt(price_list + data_price);
	});

	price_list = parseInt(
		price_list + $(".swatch_options input:checked+.swatch-element .prod-swatch-col-2").data("price")
	);
	$(".total-price-addon").text(Shopify.formatMoney(price_list, currencyFormat));

	var add_length = $(".addon-item.active").length;
	$(".addon-prod-qty").text(add_length);
 
    $(".jar-selection-section ").eq(0).addClass('active');
    

  
	if (window.innerWidth < 798) {
		$(".jar-selection-section .addon").flickity({
			contain: true,
			groupCells: true,
			draggable: true,
			// autoPlay: true,
			pageDots: false,
			prevNextButtons: true,
			// wrapAround: true,
		});
		$(".posy-selection .addon").flickity({
			contain: true,
			groupCells: true,
			draggable: true,
			// autoPlay: true,
			pageDots: false,
			prevNextButtons: true,
			// wrapAround: true,
		});
	}
});

function remove_bundle(bundle_prop, bundle_id) {
	var id_arry = {};
	$(".CartItem").each(function (e) {
		var all_prod_prop = $(this).find(".wc_custom_Custom_Bundle").data("prop");
		if (bundle_prop == all_prod_prop) {
			var cuurent_var_id = $(this).find(".cart-remove").data("id");
			console.log("cuurent_var_id", cuurent_var_id);
			id_arry[cuurent_var_id] = 0;
		}
	});
	$.ajax({
		type: "POST",
		url: "/cart/update.js",
		data: { updates: id_arry },
		dataType: "json",
		beforeSend: function () {},
		success: function (data) {
			ajaxCart.load();
		},
		error: function (error, textStatus) {},
	});
}

async function clearCart() {
	// console.log("clearing cart items....");
	try {
		window.location.href = window.Shopify.routes.root + "cart";
		return;
		await fetch(window.Shopify.routes.root + "cart/clear.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
		});
		window.scrollTo(0, 0);
		// location.reload();
		addItemsToCart();
	} catch (error) {
		console.error(error);
	}
	// finally {
	//  window.scrollTo(0, 0);
	//  location.reload();
	// }
}

function addItemsToCart() {
	var input_val = $(".input-text.form-control").val();
	const personalizedCandleMessage =
		$(".personalized-input-container.candle #personalized_message").val() || "";
   const personalizedProseccoMessage =
		$(".personalized-input-container.prosecco #personalized_message").val() || "";
	const personalizedJarMessage =
		$(".personalized-input-container.jar #personalized_message").val() || "";

	if (input_val != "") {
		var $th_button = $(this);
		var $th_id_array = new Array();
		var prop_multi_id = [];
		jQuery(".addon-item.active").each(function (index, value) {
			var pro_id = $(this).data("id");
			// var $th_temQTY = '1';
			const $th_temQTY = $(this).find(".des .addon-qty-container input").val();
			var $th_temVID = pro_id;
			prop_multi_id.push($(this).data("id"));

            var proTags = $(this).attr("data-tag");
            if(proTags != undefined){
              if(proTags.indexOf("product:imageupload") != -1){
                var imgURL = $(".product-addons-cover .polaroid-img-preview").attr("src");
                $th_id_array.push({ variant_id: $th_temVID, quantity: $th_temQTY, properties: { 'polaroid photo': imgURL } });
              }else{
                $th_id_array.push({ variant_id: $th_temVID, quantity: $th_temQTY });
              }
            }else{
              $th_id_array.push({ variant_id: $th_temVID, quantity: $th_temQTY });
            }
			
		});
		$th_id_array.reverse();
		var properties_multi_list = prop_multi_id.join("-");
		var form_id = $(".shopify-product-form").attr("id");

		function bundle_addtocart() {
			if ($th_id_array.length > 0) {
				var $th_request = $th_id_array.shift();
				var $th_tempId = $th_request.variant_id;
				var $th_tempQTY = $th_request.quantity;

				console.log("properties_multi_list", properties_multi_list);
                
				var data = {
					id: $th_tempId,
					quantity: $th_tempQTY,
				};
               
                if($th_request.properties != undefined){
                  data = {
    					id: $th_tempId,
    					quantity: $th_tempQTY,
                        properties: $th_request.properties
    				};
                }
              

				if ($th_tempId == "41886952325300") {
					data = {
						id: $th_tempId,
						quantity: $th_tempQTY,
						properties: {
							message: personalizedCandleMessage,
						},
					};
				}
              

              if ($th_tempId == "43576574050484") {
					data = {
						id: $th_tempId,
						quantity: $th_tempQTY,
						properties: {
							message: personalizedProseccoMessage,
						},
					};
				}

				if ($th_tempId == "41962751000756" ) {
					data = {
						id: $th_tempId,
						quantity: $th_tempQTY,
						properties: {
							message: personalizedJarMessage,
						},
					};
				}

              if ($th_tempId == "42742459531444" ) {
					data = {
						id: $th_tempId,
						quantity: $th_tempQTY,
						properties: {
							message: personalizedJarMessage,
						},
					};
				}

				var $th_ajax_without_properties = {
					type: "POST",
					url: "/cart/add.js",
					data: data,
					dataType: "json",
					beforeSend: function () {
						$th_button.addClass("processing");
						$th_button.attr("disabled", true);
					},
					success: function (cart) {
						bundle_addtocart();
					},
					error: function (XMLHttpRequest, textStatus) {
						$th_button.children("span.button_text").text("Error");
						console.log(XMLHttpRequest);
					},
				};
				$.ajax($th_ajax_without_properties);
			} else {
				window.location.href = "/cart";
			}
		}
		setTimeout(function () {
			$.ajax({
				type: "POST",
				url: "/cart/add.js",
				dataType: "json",
				data: $("#" + form_id).serialize(),
				success: function (sucess) {
					bundle_addtocart();
				},
				error: function (error) {},
			});
		}, 300);
	}
    else {
		$(".input-text.form-control").addClass("active-error");
		console.log("Here it suppose to scroll");
		$("html, body").animate(
			{
				scrollTop: parseInt($(".perdonalise-cover").offset().top - 300),
			},
			100
		);
		return false;
	}
  
}

$(document).on("click", ".global-button", async function (e) {
	e.preventDefault();
    $(".cimagemessage").hide();
	const personalizedCandleMessage =
		$(".personalized-input-container.candle #personalized_message").val() || "";
	let hasPersonalizedCandle = false;
	const personalizedJarMessage =
		$(".personalized-input-container.jar #personalized_message").val() || "";

	const personalizedProseccoMessage =
		$(".personalized-input-container.prosecco #personalized_message").val() || "";	
		
	let hasPersonalizedJar = false;
	let hasSelectedAJar = document.querySelectorAll(".jar-selection-section .addon-item.active")
		.length
		? true
		: false;
	const hasSelectedPosy = document.querySelectorAll(".posy-selection .addon-item.active")
		.length
		? true
		: false;

	const freePostcardSection = document.querySelector(".free-postcard-selection");

	if (freePostcardSection) {
		const handleSelectedSleeves =
			freePostcardSection.querySelectorAll(".addon-item.active").length > 0;

		if (!handleSelectedSleeves) {
			Swal.fire({
			title: "Oops...",
			width: 700,
			html: "Please select a sleeve to proceed.",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
			}).then(() => {
			$("html, body").animate(
				{
				scrollTop:
					parseInt($(".free-postcard-selection").offset().top - 200),
				},
				200
			);
			});
			return;
		}
	}
	
	if (!hasSelectedPosy && isBAB) {
		Swal.fire({
			// icon: 'error',
			title: "Oops...",
			width: 700,
			html: "Please select a posy to proceed.",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
		}).then((result) => {
			$("html, body").animate(
				{
					scrollTop: parseInt($(".posy-selection").offset().top - 200),
				},
				200
			);
		});
		return;
	}

	if (!hasSelectedAJar && hasJarCollection && !isBAB) {
		Swal.fire({
			// icon: 'error',
			title: "Oops...",
			width: 700,
			html: "Please select a free jar quote to proceed.",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
		}).then((result) => {
			$("html, body").animate(
				{
					scrollTop: parseInt($(".jar-selection-section").offset().top - 200),
				},
				200
			);
		});
		return;
	}

  $(document).ready(function() {
      $('.jar-item').on('click', function() {
        // Remove the active class from all jar items
        $('.jar-item').removeClass('active');
        
        // Add the active class to the clicked jar item
        $(this).addClass('active');
         
      });
  });

	// check for personalised candle and input
	jQuery(".addon-item.active").each(function (index, value) {
		var pro_id = $(this).data("id");

		if (pro_id == "43576574050484") {
			hasPersonalizedCandle = true;
		}
		if (pro_id == "41962751000756") {
			hasPersonalizedJar = true;
		}

      if (pro_id == "42742459531444") {
			hasPersonalizedJar = true;
		}
	});

	if (hasPersonalizedJar && !personalizedJarMessage) {
		Swal.fire({
			// icon: 'error',
			title: "Oops...",
			width: 700,
			html: "It seems you have selected personalised jar, please make sure you have provide the name, nickname or message you want to appear on the jar",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
		});
		return;
	}

	if (hasPersonalizedCandle && !personalizedProseccoMessage) {
		Swal.fire({
			// icon: 'error',
			title: "Oops...",
			width: 700,
			html: "It seems you have selected personalised candle, please make sure you have provide the name, nickname or message you want to appear on the candle",
			confirmButtonColor: "#ee4382",
			confirmButtonText: "Ok",
		});
		return;
	}

	// only allow user to select one main product
	// fetch cart item and check from there
	// start - blocking if cart already has a flower product
	const data = await fetch(window.Shopify.routes.root + "cart.js");
	const cartItems = await data.json();
	let itemCount = cartItems.items.reduce((count, item) => {
		if (
			!item.product_type ||
			item.product_type === "Bundle" ||
			item.product_type === "BAB" ||
			item.product_type === "Gift Cards"
		) {
			return count + item.quantity;
		} else {
			return count;
		}
	}, 0);

	console.log(itemCount);

	if (itemCount >= 12) {
		Swal.fire({
			// icon: 'error',
			title: "Oops...",
			width: 700,
			html:
				"Oops, you can only check out with 12 main product in your cart at a time.<br><br>" +
				"Please proceed to your cart and checkout first before placing a second order, or you can clear cart below.<br><br>" +
				'For bulk or corporate gifting you can head to our dedicated <a href="https://lvlycorporate.com.au/"><strong>Corporate website</strong></a>.<br><br>',
			confirmButtonColor: "#ee4382",
			cancelButtonColor: "#383c4f",
			confirmButtonText: "Clear Cart",
			showCancelButton: true,
		}).then(async (result) => {
			if (result.isConfirmed) {
				// clear cart
				await clearCart();
			}
		});
		return;
	}

    //Check if Upload Photo start
      if($("#uploadcare--widget__text").length){
          var uploadeddata = $.trim($(".uploadcare--widget__file-name").html());
          if(uploadeddata == '' || uploadeddata == null){
            $("#uploadcare--widget__text").show();
            $("#uploadcare--widget__text").html('<p class="cimagemessage" style="color:red">Please upload your photo</p>');
                 $("html, body").animate(
      				{
      					scrollTop: parseInt($("#smartwishlist").offset().top - 200),
      				},
      				100
      			);
            return;
          }
      }
    //Check if Upload Photo end 


    //Check if Polaroid photo upload
      if($(".product-addons-cover .personalised-upload-cover").length){
          if($(".product-addons-cover .personalised-upload-cover").is(":visible")){
            Swal.fire({
    			// icon: 'error',
    			title: "Oops...",
    			width: 700,
    			html:
    				"Please upload your photo.<br><br>" ,
    			confirmButtonColor: "#ee4382",
    			cancelButtonColor: "#383c4f",
    			confirmButtonText: "Close",
    			showCancelButton: true,
    		});
    		return;
          }
      }
    //Check if Polaroid photo upload end 

  
	// end - blocking if cart already has a flower product
	addItemsToCart();
});

$(document).keyup(function (event) {
	$(".input-text.form-control").removeClass("active-error");
});

async function getProductDetails(URLPath) {
	try {
		const data = await fetch(window.location.origin + URLPath);
		const response = await data.json();
		return response;
	} catch (err) {
		console.log(err);
	}
}

$("button#view-details-addon").modaal({
	type: "inline",
	content_source: ".addon_pop_custom",
	before_open: async function (e) {
		// fetch product info
		const pro_url = $(e.currentTarget).attr("data-src");
		let data = await getProductDetails(pro_url);
		let imagesHTML = "";
		if (data.images.length > 0) {
			data.images.forEach((image) => {
				imagesHTML += `<li class="splide__slide"><img src="${image}"></li>`;
			});
		}
		// insert all details and generate photos
		addOnModalButton.dataset.vid = $(e.currentTarget).data("vid");
		$(".product-modal-details .product-modal-title").text(data.title);
		$(".product-modal-details .product-modal-description").html(data.description);
		$("#addon-modal-photos").html(imagesHTML);
		// destroy splide and init splide again
		new Splide("#addon_carousel", {
			type: "slide",
			pagination: false,
			arrows: false,
		}).mount();
	},
	after_close: function () {
		new Splide("#addon_carousel", {
			type: "slide",
			pagination: false,
			arrows: false,
		}).destroy();
	},
});

